import VChartWrapper from './components/Charts';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';

export * from './components';

export const RechartsWrapper = (props) => {
  return VChartWrapper(props);
};

console.log('Initializing Agent Framework application...');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

console.log('Application rendered successfully.'); 